// The values presented here are used externally (in emails mostly)
// and should be changed after other teams coordination only

export const newUserFlowFlag = 'ecomm'
export const skipToLoginFlag = 'skipToLogin'
export const triggerAcceptInvite = 'acceptInvite'
